import React, { useState } from 'react';

// Importing PNG icons for social media
import facebookIcon from '../icons/Facebook_tt.png';
import googleIcon from '../icons/Google_tt.png';
import instagramIcon from '../icons/Instagram_tt.png';
import linkedinIcon from '../icons/linkedin_tt.png';
import tiktokIcon from '../icons/tiktok_tt.png';
import twitterIcon from '../icons/X_tt.png';
import whatsappIcon from '../icons/WhatsApp_tt.png';
import yelpIcon from '../icons/Yelp_tt.png';

const socialMediaIcons = {
  FACEBOOK: facebookIcon,
  INSTAGRAM: instagramIcon,
  TIKTOK: tiktokIcon,
  LINKEDIN: linkedinIcon,
  WHATSAPP: whatsappIcon,
  TWITTER: twitterIcon,
  YELP: yelpIcon,
  GOOGLE_REVIEWS: googleIcon,
};

const test = 1;
const SocialMediaDeeplinkGenerator = ({ type, id, name }) => {
  const [message, setMessage] = useState(''); // State to show instructions
  let deeplink = '';
  let fallbackUrl = '';

  // Determine the deep link and fallback URL based on the type
  switch (type) {
    case 'FACEBOOK':
      deeplink = `fb://profile/${id}`;
      fallbackUrl = `https://facebook.com/${id}`;
      break;
    case 'INSTAGRAM':
      deeplink = `instagram://user?username=${id}`;
      fallbackUrl = `https://instagram.com/${id}`;
      break;
    case 'TIKTOK':
      deeplink = `snssdk1233://user/profile/${id}`;
      fallbackUrl = `https://www.tiktok.com/@${id}`;
      break;
    case 'LINKEDIN':
      deeplink = `linkedin://profile/${id}`;
      fallbackUrl = `https://linkedin.com/in/${id}`;
      break;
    case 'WHATSAPP':
      deeplink = `whatsapp://send?phone=${id}`;
      fallbackUrl = `https://wa.me/${id}`;
      break;
    case 'TWITTER':
      deeplink = `twitter://user?screen_name=${id}`;
      fallbackUrl = `https://twitter.com/${id}`;
      break;
    case 'YELP':
      deeplink = `yelp:///biz/${id}`;
      fallbackUrl = `https://www.yelp.com/biz/${id}`;
      break;
    case 'GOOGLE_REVIEWS':
      deeplink = `https://maps.google.com/?q=${id}`;
      fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${id}`;
      break;
    default:
      throw new Error('Unsupported social media type');
  }

  return (
    <div className="social-centered-container">
      <a
        href={deeplink}
        onClick={(e) => {
          e.preventDefault(); // Prevent default behavior
          window.location = deeplink;
          setTimeout(() => {
            window.location = fallbackUrl;
          }, 1000);
        }}
      >
        <img
          src={socialMediaIcons[type]}
          alt={`${name} icon`}
          className="icon"
        />
      </a>
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default SocialMediaDeeplinkGenerator;
